<template>
  <v-container fluid class="timetracking-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="findTimeTrackingDialog = true"
              >
              <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="timetrackings-table"
              show-select
              sort-desc
              single-select
              item-key="_id"
              sort-by="createdAt"
              :footer-props="footer"
              :headers="headers"
              :items="timeTrackings"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="deletedialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Time Tracking?
                    </v-card-title>

                    <v-card-text>
                      {{ deletetimetracking.employeename }} - {{ deletetimetracking.datetime }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="deletedialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletetimetracking)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.timetrackingimage="{ item }">
                <img v-bind:src="item.timetrackingimage" alt="" width="100px">
              </template>
              <template v-slot:item.employeename="{ item }">
                <a class="primaryConst--text">{{ item.employeename }}</a>
              </template>
              <template v-slot:item.geolocation="{ item }">
                <a class="primaryConst--text" target="_blank" v-bind:href="'http://maps.google.com/maps?q=' + item.geolocation.replace(' ', '')">Map</a>
              </template>
              <template v-slot:item.timetrackingemail="{ item }">
                <a class="primaryConst--text">{{ item.timetrackingemail }}</a>
              </template>

              <template v-slot:item.datetime="{ item }">
                {{ new Date(item.datetime).toLocaleString("en-SG", { timeZone: timezone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }}
              </template>
              <template v-slot:item.timetype="{ item }">
                <v-chip
                  :color="item.timetype === 'Time In' ? 'primaryConst white--text' : 'secondaryConst white--text'" small>
                  {{ item.timetype }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                <!-- <v-btn icon color="primary" @click="deleteItem(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn> -->
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
        <v-row justify="center">
    <v-dialog
      v-model="findTimeTrackingDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Employee</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="employees.filter(x=>x.employeestatus=='Active').map(x => {
                            return {text: x.employeename, value: x._id};
                          })"
                  v-model="query.employeeid"
                  label="Employee"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="findTimeTrackingDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findTimeTracking"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getTimeZone } from '../../../util/tools';

export default {
  name: 'TimeTrackingList',
  data() {
    return {
      deletedialog: false,
      deletetimetracking: {},
      headers: [
        { text: 'Type', value: 'timetype' },
        { text: 'Image', value: 'timetrackingimage', sortable: false },
        { text: 'Time', value: 'datetime' },
        { text: 'Name', value: 'employeename' },
        { text: 'Geolocation', value: 'geolocation' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      query: {},
      timeTrackings: [],
      findTimeTrackingDialog: false,
      timezone: null,
    }
  },

  computed: {
    ...mapState('Employee', ['employees',]),
    ...mapState('TimeTracking', ['timetrackings', 'isReceiving', 'isDeleting', 'idToDelete', 'timetrackingsMessage', 'isUpdating']),
  },
  async created () {
    let companyid = localStorage.getItem('companyid');
    this.timezone = getTimeZone(companyid);
    console.log(this.timezone);
    await this.getTimeTrackingsRequest();
    this.timeTrackings = this.timetrackings;
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
  methods: {
    ...mapActions('TimeTracking', ["getTimeTrackingsRequest", "getTimeTrackingsQuery", "deleteTimeTrackingRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    async deleteItem(item) {
      await this.deleteTimeTrackingRequest({_id: item._id});
      this.deletedialog = false;
      this.timeTrackings = this.timetrackings;
    },
    deleteDialog(item) {
      this.deletedialog = true;
      this.deletetimetracking = {
        _id: item._id,
        employeename: item.employeename,
        datetime: item.datetime,
      }
    },
    editItem(item) {
      console.log(item);
      this.$router.push({ name: 'TimeTrackingEdit', params: item })
    },
    async findTimeTracking(){
      this.findTimeTrackingDialog = false;
      let result = await this.getTimeTrackingsQuery(this.query);
      this.timeTrackings = result;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
